import React from "react";
import CloseIcon from "mdi-react/CloseIcon";
import { Modal, Row, Col, Button, ButtonToolbar } from "reactstrap";
import ViewInvoiceSummary from "../../Report/Invoices/components/ViewInvoiceSummary";


const InvoiceSummaryData = ({ summaryData, isOpen, setOpen, toggle, onClickDownloadInvoiceSummary }) => {
  
  return (
    <Modal
      className={`program-settings modal-2col modal-lg`}
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="close cursor-pointer">
        <CloseIcon onClick={toggle} size={30} />
      </div>
      <div className="modal-body mb-4">
        <Row className="mb-4">
          <Col md="8" lg="8" xl="8">
            <div className="modal__title">
              <h3 className="mb-4">View Invoice Summary</h3>
            </div>
          </Col>
          <Col md="4" lg="4" xl="4" className="text-right">
            <ButtonToolbar className="modal__footer flex justify-content-right w100">
              <Button
                outline
                color="primary"
                className="mr-0"
                onClick={() => { onClickDownloadInvoiceSummary() }}
              >
                Download Invoice Summary
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
        <br/>
        {summaryData.length > 0 && summaryData.map((item, i) => {
          return(<>
            <ViewInvoiceSummary invoice={item} />
          </>)
        })}
      </div>
      
    </Modal>
  );
};

export default InvoiceSummaryData;
